const _umbrellas = {
	'apple-umbrella': {
		name: 'apple umbrella',
	},
	'bat-umbrella': {
		name: 'bat umbrella',
	},
	'beach-umbrella': {
		name: 'beach umbrella',
	},
	'bear-umbrella': {
		name: 'bear umbrella',
	},
	'black-chic-umbrella': {
		name: 'black chic umbrella',
	},
	'black-lace-umbrella': {
		name: 'black lace umbrella',
	},
	'blue-dot-parasol': {
		name: 'blue dot parasol',
	},
	'blue-shiny-bows-parasol': {
		name: 'blue shiny-bows parasol',
	},
	'blue-umbrella': {
		name: 'blue umbrella',
	},
	'busted-umbrella': {
		name: 'busted umbrella',
	},
	'camo-umbrella': {
		name: 'camo umbrella',
	},
	'candy-umbrella': {
		name: 'candy umbrella',
	},
	'cherry-umbrella': {
		name: 'cherry umbrella',
	},
	'cherry-blossom-umbrella': {
		name: 'cherry-blossom umbrella',
	},
	'dal-umbrella': {
		name: 'DAL umbrella',
	},
	'eggy-parasol': {
		name: 'eggy parasol',
	},
	'exquisite-parasol': {
		name: 'exquisite parasol',
	},
	'fairy-tale-umbrella': {
		name: 'fairy-tale umbrella',
	},
	'fish-umbrella': {
		name: 'fish umbrella',
	},
	'frog-umbrella': {
		name: 'frog umbrella',
	},
	'gelato-umbrella': {
		name: 'gelato umbrella',
	},
	'ghost-umbrella': {
		name: 'ghost umbrella',
	},
	'grape-umbrella': {
		name: 'grape umbrella',
	},
	'green-chic-umbrella': {
		name: 'green chic umbrella',
	},
	'green-umbrella': {
		name: 'green umbrella',
	},
	'hydrangea-umbrella': {
		name: 'hydrangea umbrella',
	},
	'kabuki-umbrella': {
		name: 'kabuki umbrella',
	},
	'kiwi-umbrella': {
		name: 'kiwi umbrella',
	},
	'lacy-parasol': {
		name: 'lacy parasol',
	},
	'ladybug-umbrella': {
		name: 'ladybug umbrella',
	},
	'leaf-umbrella': {
		name: 'leaf umbrella',
	},
	'lemon-umbrella': {
		name: 'lemon umbrella',
	},
	'logo-umbrella': {
		name: 'logo umbrella',
	},
	'maple-leaf-umbrella': {
		name: 'maple-leaf umbrella',
	},
	'melon-umbrella': {
		name: 'melon umbrella',
	},
	'mini-flower-print-umbrella': {
		name: 'mini-flower-print umbrella',
	},
	'mint-umbrella': {
		name: 'mint umbrella',
	},
	'mush-umbrella': {
		name: 'mush umbrella',
	},
	'nook-inc-umbrella': {
		name: 'Nook Inc. umbrella',
	},
	'orange-umbrella': {
		name: 'orange umbrella',
	},
	'panda-umbrella': {
		name: 'panda umbrella',
	},
	'paper-parasol': {
		name: 'paper parasol',
	},
	'patterned-vinyl-umbrella': {
		name: 'patterned vinyl umbrella',
	},
	'peach-umbrella': {
		name: 'peach umbrella',
	},
	'pear-umbrella': {
		name: 'pear umbrella',
	},
	'petal-parasol': {
		name: 'petal parasol',
	},
	'picnic-umbrella': {
		name: 'picnic umbrella',
	},
	'pineapple-umbrella': {
		name: 'pineapple umbrella',
	},
	'pink-shiny-bows-parasol': {
		name: 'pink shiny-bows parasol',
	},
	'pink-umbrella': {
		name: 'pink umbrella',
	},
	'purple-chic-umbrella': {
		name: 'purple chic umbrella',
	},
	'purple-shiny-bows-parasol': {
		name: 'purple shiny-bows parasol',
	},
	'rainbow-umbrella': {
		name: 'rainbow umbrella',
	},
	'raindrop-umbrella': {
		name: 'raindrop umbrella',
	},
	'red-chic-umbrella': {
		name: 'red chic umbrella',
	},
	'red-umbrella': {
		name: 'red umbrella',
	},
	'snowflake-umbrella': {
		name: 'snowflake umbrella',
	},
	'spider-umbrella': {
		name: 'spider umbrella',
	},
	'strawberry-umbrella': {
		name: 'strawberry umbrella',
	},
	'striped-umbrella': {
		name: 'striped umbrella',
	},
	'sunny-parasol': {
		name: 'sunny parasol',
	},
	'tartan-check-umbrella': {
		name: 'tartan-check umbrella',
	},
	'toad-parasol': {
		name: 'Toad parasol',
	},
	'two-tone-umbrella': {
		name: 'two-tone umbrella',
	},
	'vinyl-umbrella': {
		name: 'vinyl umbrella',
	},
	'watermelon-umbrella': {
		name: 'watermelon umbrella',
	},
	'white-shiny-bows-parasol': {
		name: 'white shiny-bows parasol',
	},
};

export { _umbrellas };
